import { lazy } from "react";

// project import
import Loadable from "../components/Loadable";
import DashboardLayout from "../layout/Dashboard";
import PagesLayout from "../layout/Pages";
import SimpleLayout from "../layout/Simple";
import { SimpleLayoutType } from "../config";

// render - dashboard
const DashboardDefault = Loadable(
  lazy(() => import("../pages/dashboard/resumo")),
);
const DashboardAnalytics = Loadable(
  lazy(() => import("../pages/dashboard/analytics")),
);

const ListaEmpresas = Loadable(
  lazy(() => import("../pages/apps/empresas/ListaEmpresas")),
);
const ListaDepartamentos = Loadable(
  lazy(() => import("../pages/apps/departamentos/ListaDepartamentos")),
);
const ListaProcessos = Loadable(
  lazy(() => import("../pages/apps/processos/ListaProcessos")),
);
const ListaDados = Loadable(
  lazy(() => import("../pages/apps/dados/ListaDados")),
);
const ListaContas = Loadable(
  lazy(() => import("../pages/apps/contas/ListaContas")),
);
const ListaFaseTeste = Loadable(
  lazy(() => import("../pages/apps/configuracoes/testes/ListaFaseTeste")),
);
const ListaQuestionariosMain = Loadable(
  lazy(
    () =>
      import(
        "../pages/apps/configuracoes/questionarios/ListaQuestionariosMain"
      ),
  ),
);
const ListaAtivos = Loadable(
  lazy(() => import("../pages/apps/ativos/ListaAtivos")),
);
const ListaRiscos = Loadable(
  lazy(() => import("../pages/apps/riscos/ListaRiscos")),
);
const ListaCiclos = Loadable(
  lazy(() => import("../pages/apps/ciclos/ListaCiclos")),
);
const ListaControles = Loadable(
  lazy(() => import("../pages/apps/controles/ListaControles")),
);
const ListaIpes = Loadable(lazy(() => import("../pages/apps/ipes/ListaIpes")));
const NovaEmpresa = Loadable(
  lazy(() => import("../pages/apps/empresas/NovaEmpresa")),
);
const ListaIndice = Loadable(
  lazy(() => import("../pages/apps/indices/ListaIndices")),
);
const ListaIncidentes = Loadable(
  lazy(() => import("../pages/apps/incidentes/ListaIncidentes")),
);
const ListaCategorias = Loadable(
  lazy(() => import("../pages/apps/categorias/ListaCategorias")),
);
const ListaPerfil = Loadable(
  lazy(() => import("../pages/apps/perfisAnalise/ListaPerfis")),
);
const ListaNormativos = Loadable(
  lazy(() => import("../pages/apps/normativos/ListaNormativos")),
);
const ListaLibreOffice = Loadable(
  lazy(() => import("../pages/apps/normativos/ListaLibreOffice")),
);
const EditorArquivo = Loadable(
  lazy(() => import("../pages/apps/normativos/EditorArquivo")),
);
const ListaPlanos = Loadable(
  lazy(() => import("../pages/apps/planos/ListaPlanos")),
);
const ListaESG = Loadable(
  lazy(() => import("../pages/apps/esg/ListaPerfilEsg")),
);
const ListaColaboradores = Loadable(
  lazy(() => import("../pages/apps/colaboradores/ListaColaboradores")),
);
const ListaImpactoEsg = Loadable(
  lazy(() => import("../pages/apps/esg/ListaImpactoEsg")),
);
const ListaTema = Loadable(lazy(() => import("../pages/apps/esg/ListaTema")));
const ListaOds = Loadable(lazy(() => import("../pages/apps/esg/ListaOds")));
const ListaGrupoTemas = Loadable(
  lazy(() => import("../pages/apps/esg/ListaGrupoTemas")),
);
const ListaPadroesFrameworks = Loadable(
  lazy(() => import("../pages/apps/esg/ListaPadroesFrameworks")),
);
const ListaFrameworks = Loadable(
  lazy(() => import("../pages/apps/esg/ListaFrameworks")),
);
const ListaPriorizacao = Loadable(
  lazy(() => import("../pages/apps/esg/ListaPriorizacao")),
);
const ListaObjetivos = Loadable(
  lazy(() => import("../pages/apps/objetivos/ListaObjetivos")),
);
const ListaProjetos = Loadable(
  lazy(() => import("../pages/apps/esg/ListaProjetos")),
);
const ListaDeficiencias = Loadable(
  lazy(() => import("../pages/apps/controles/ListaDeficiencias")),
);
const ListaTestes = Loadable(
  lazy(() => import("../pages/apps/controles/ListaTestes")),
);
const ListaIndicadores = Loadable(
  lazy(() => import("../pages/apps/esg/ListaIndicadores")),
);
const ListaMedida = Loadable(
  lazy(() => import("../pages/apps/esg/ListaMedidas")),
);
const ListaColeta = Loadable(
  lazy(() => import("../pages/apps/esg/ListaColeta")),
);
const ListaDimensao = Loadable(
  lazy(() => import("../pages/apps/esg/ListaDimensao")),
);
const ListaFonteDeDados = Loadable(
  lazy(() => import("../pages/apps/esg/ListaFonteDeDados")),
);
const ListaGestaoColeta = Loadable(
  lazy(
    () => import("../pages/apps/configuracoes/coleta/ListagemDeGestaoDeColeta"),
  ),
);
const ListaFatoresEmissao = Loadable(
  lazy(() => import("../pages/apps/esg/ListaFatoresEmissao")),
);
const NovoDepartamento = Loadable(
  lazy(() => import("../pages/apps/departamentos/NovoDepartamento")),
);
const NovoProcesso = Loadable(
  lazy(() => import("../pages/apps/processos/NovoProcesso")),
);
const NovoDado = Loadable(lazy(() => import("../pages/apps/dados/NovoDado")));
const NovaDimensao = Loadable(
  lazy(() => import("../pages/apps/configuracoes/esg/NovaDimensao")),
);
const NovoESG = Loadable(
  lazy(() => import("../pages/apps/configuracoes/esg/NovoPerfilEsg")),
);
const NovoTema = Loadable(
  lazy(() => import("../pages/apps/configuracoes/esg/NovoTema")),
);
const NovoGrupoTemas = Loadable(
  lazy(() => import("../pages/apps/configuracoes/esg/NovoGrupoTemas")),
);
const NovaPriorizacao = Loadable(
  lazy(() => import("../pages/apps/configuracoes/esg/NovaPriorizacao")),
);
const NovaConta = Loadable(
  lazy(() => import("../pages/apps/contas/NovaConta")),
);
const NovoAtivo = Loadable(
  lazy(() => import("../pages/apps/ativos/NovoAtivo")),
);
const NovoRisco = Loadable(
  lazy(() => import("../pages/apps/riscos/NovoRisco")),
);
const NovoIndicador = Loadable(
  lazy(() => import("../pages/apps/configuracoes/esg/NovoIndicador")),
);
const NovoPadroesFrameworks = Loadable(
  lazy(() => import("../pages/apps/configuracoes/esg/NovoPadroesFrameworks")),
);
const NovoFramework = Loadable(
  lazy(() => import("../pages/apps/configuracoes/esg/NovoFramework")),
);
const NovoImpactoEsg = Loadable(
  lazy(() => import("../pages/apps/configuracoes/esg/NovoImpactoEsg")),
);
const NovaMedida = Loadable(
  lazy(() => import("../pages/apps/configuracoes/esg/NovaMedida")),
);
const NovoCiclo = Loadable(
  lazy(() => import("../pages/apps/ciclos/NovoCiclo")),
);
const NovaFaseTeste = Loadable(
  lazy(() => import("../pages/apps/configuracoes/testes/NovaFaseTeste")),
);
const NovoIndice = Loadable(
  lazy(() => import("../pages/apps/indices/NovoIndice")),
);
const NovoFatoresEmissao = Loadable(
  lazy(() => import("../pages/apps/configuracoes/esg/NovoFatoresEmissao")),
);
const NovoIncidente = Loadable(
  lazy(() => import("../pages/apps/incidentes/NovoIncidente")),
);
const NovaCategoria = Loadable(
  lazy(() => import("../pages/apps/categorias/NovaCategoria")),
);
const NovoPerfil = Loadable(
  lazy(() => import("../pages/apps/perfisAnalise/NovoPerfil")),
);
const DetalheColeta = Loadable(
  lazy(() => import("../pages/apps/configuracoes/coleta/DetalheColeta")),
);
const NovaColeta = Loadable(
  lazy(() => import("../pages/apps/configuracoes/coleta/NovaColeta")),
);
const NovoControle = Loadable(
  lazy(() => import("../pages/apps/controles/NovoControle")),
);
const NovoColaborador = Loadable(
  lazy(() => import("../pages/apps/colaboradores/NovoColaborador")),
);
const NovaNormativa = Loadable(
  lazy(() => import("../pages/apps/configuracoes/cadastros/NovaNormativa")),
);
const NovaFonteDeDados = Loadable(
  lazy(() => import("../pages/apps/configuracoes/esg/NovaFonteDeDados")),
);
const NovoPlano = Loadable(
  lazy(() => import("../pages/apps/configuracoes/cadastros/NovoPlano")),
);
const NovaDeficiencia = Loadable(
  lazy(() => import("../pages/apps/configuracoes/cadastros/NovaDeficiencia")),
);
const NovoTeste = Loadable(
  lazy(() => import("../pages/apps/configuracoes/testes/NovoTeste")),
);
const NovoIpe = Loadable(lazy(() => import("../pages/apps/ipes/NovoIpe")));
const NovoOds = Loadable(
  lazy(() => import("../pages/apps/configuracoes/esg/NovoOds")),
);
const NovoObjetivo = Loadable(
  lazy(() => import("../pages/apps/objetivos/NovoObjetivo")),
);
const NovoQuestionario = Loadable(
  lazy(
    () => import("../pages/apps/configuracoes/questionarios/NovoQuestionario"),
  ),
);
const NovoProjeto = Loadable(
  lazy(() => import("../pages/apps/configuracoes/esg/NovoProjeto")),
);
// Modulo novo "Projetos (Engagement)" — nao confundir com o "Projeto" antigo acima
const ListaProjetosEngagement = Loadable(
  lazy(() => import("../pages/apps/engagement/listaProjetos")),
);
const NovoProjetoEngagement = Loadable(
  lazy(() => import("../pages/apps/engagement/novoProjeto")),
);
const NovoObjetivoEngagement = Loadable(
  lazy(() => import("../pages/apps/engagement/novoObjetivo")),
);
const NovaTarefaEngagement = Loadable(
  lazy(() => import("../pages/apps/engagement/novaTarefa")),
);
const NovaColetaEngagement = Loadable(
  lazy(() => import("../pages/apps/engagement/novaColeta")),
);
const NovoStepEngagement = Loadable(
  lazy(() => import("../pages/apps/engagement/novoStep")),
);
const ListaProgramacoesEngagement = Loadable(
  lazy(() => import("../pages/apps/engagement/listaProgramacoes")),
);
const NovaProgramacaoEngagement = Loadable(
  lazy(() => import("../pages/apps/engagement/novaProgramacao")),
);
const ListaAvaliacaoRisco = Loadable(
  lazy(() => import("../pages/apps/avaliacoesRisco/ListaAvaliacaoRisco")),
);
const NovaAvaliacaoRisco = Loadable(
  lazy(() => import("../pages/apps/avaliacoesRisco/NovaAvaliacaoRisco")),
);
const LibreOffice = Loadable(
  lazy(() => import("../pages/extra-pages/sample-page")),
);
const AuthLogin = Loadable(lazy(() => import("../pages/auth/login")));
const AuthRegister = Loadable(lazy(() => import("../pages/auth/register")));
const TrocarSenha = Loadable(
  lazy(() => import("../pages/apps/colaboradores/TrocarSenha")),
);
const ListaLogs = Loadable(lazy(() => import("../pages/apps/logs/ListaLogs")));
const ListaNotificacoes = Loadable(
  lazy(() => import("../pages/apps/notificacoes/ListaNotificacoes")),
);
const DetalhesUsuario = Loadable(
  lazy(() => import("../sections/apps/chat/UserDetails")),
);

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: "/",
  children: [
    {
      path: "/",
      element: <DashboardLayout />,
      children: [
        {
          path: "dashboard",
          children: [
            {
              path: "resumo",
              element: <DashboardDefault />,
            },
            {
              path: "analytics",
              element: <DashboardAnalytics />,
            },
          ],
        },
        {
          path: "empresas",
          children: [
            {
              path: "lista",
              element: <ListaEmpresas />,
            },
            {
              path: "criar",
              element: <NovaEmpresa />,
            },
          ],
        },
        {
          path: "departamentos",
          children: [
            {
              path: "lista",
              element: <ListaDepartamentos />,
            },
            {
              path: "criar",
              element: <NovoDepartamento />,
            },
          ],
        },
        {
          path: "processos",
          children: [
            {
              path: "lista",
              element: <ListaProcessos />,
            },
            {
              path: "criar",
              element: <NovoProcesso />,
            },
          ],
        },
        {
          path: "dados",
          children: [
            {
              path: "lista",
              element: <ListaDados />,
            },
            {
              path: "criar",
              element: <NovoDado />,
            },
          ],
        },
        {
          path: "contas",
          children: [
            {
              path: "lista",
              element: <ListaContas />,
            },
            {
              path: "criar",
              element: <NovaConta />,
            },
          ],
        },
        {
          path: "ativos",
          children: [
            {
              path: "lista",
              element: <ListaAtivos />,
            },
            {
              path: "criar",
              element: <NovoAtivo />,
            },
          ],
        },
        {
          path: "riscos",
          children: [
            {
              path: "lista",
              element: <ListaRiscos />,
            },
            {
              path: "criar",
              element: <NovoRisco />,
            },
          ],
        },
        {
          path: "ciclos",
          children: [
            {
              path: "lista",
              element: <ListaCiclos />,
            },
            {
              path: "criar",
              element: <NovoCiclo />,
            },
          ],
        },
        {
          path: "avaliacoes",
          children: [
            {
              path: "lista",
              element: <ListaAvaliacaoRisco />,
            },
            {
              path: "criar",
              element: <NovaAvaliacaoRisco />,
            },
          ],
        },
        {
          path: "indices",
          children: [
            {
              path: "lista",
              element: <ListaIndice />,
            },
            {
              path: "criar",
              element: <NovoIndice />,
            },
          ],
        },
        {
          path: "questionarios",
          children: [
            {
              path: "criar",
              element: <NovoQuestionario />,
            },
            {
              path: "lista",
              element: <ListaQuestionariosMain />,
            },
          ],
        },
        {
          path: "incidentes",
          children: [
            {
              path: "lista",
              element: <ListaIncidentes />,
            },
            {
              path: "criar",
              element: <NovoIncidente />,
            },
          ],
        },
        {
          path: "categorias",
          children: [
            {
              path: "lista",
              element: <ListaCategorias />,
            },
            {
              path: "criar",
              element: <NovaCategoria />,
            },
          ],
        },
        {
          path: "perfis",
          children: [
            {
              path: "lista",
              element: <ListaPerfil />,
            },
            {
              path: "criar",
              element: <NovoPerfil />,
            },
          ],
        },
        {
          path: "detalheColeta",
          children: [
            {
              path: "criar",
              element: <DetalheColeta />,
            },
            {
              path: ":id",
              element: <DetalheColeta />,
            },
          ],
        },
        {
          path: "controles",
          children: [
            {
              path: "lista",
              element: <ListaControles />,
            },
            {
              path: "criar",
              element: <NovoControle />,
            },
          ],
        },
        {
          path: "ipes",
          children: [
            {
              path: "lista",
              element: <ListaIpes />,
            },
            {
              path: "criar",
              element: <NovoIpe />,
            },
          ],
        },
        {
          path: "objetivos",
          children: [
            {
              path: "lista",
              element: <ListaObjetivos />,
            },
            {
              path: "criar",
              element: <NovoObjetivo />,
            },
          ],
        },
        {
          path: "fase",
          children: [
            {
              path: "lista",
              element: <ListaFaseTeste />,
            },
            {
              path: "criar",
              element: <NovaFaseTeste />,
            },
          ],
        },
        {
          path: "projetos",
          children: [
            {
              path: "lista",
              element: <ListaProjetos />,
            },
            {
              path: "criar",
              element: <NovoProjeto />,
            },
          ],
        },
        {
          path: "normativas",
          children: [
            {
              path: "lista",
              element: <ListaNormativos />,
            },
            {
              path: "criar",
              element: <NovaNormativa />,
            },
          ],
        },
        {
          path: "normativos",
          children: [
            {
              path: "aprovar",
              element: <NovaNormativa />,
            },
          ],
        },
        {
          path: "planos",
          children: [
            {
              path: "lista",
              element: <ListaPlanos />,
            },
            {
              path: "criar",
              element: <NovoPlano />,
            },
          ],
        },
        {
          path: "deficiencias",
          children: [
            {
              path: "lista",
              element: <ListaDeficiencias />,
            },
            {
              path: "criar",
              element: <NovaDeficiencia />,
            },
          ],
        },
        {
          path: "libreOffice",
          children: [
            {
              path: "lista",
              element: <ListaLibreOffice />,
            },
            {
              // Rota semântica de edição: permite abrir um documento a partir
              // de qualquer tela do sistema apenas navegando até a URL.
              path: "arquivo/:idFile",
              element: <EditorArquivo />,
            },
            {
              path: "iframe",
              element: <LibreOffice />,
            },
          ],
        },
        {
          path: "esg",
          children: [
            {
              path: "lista",
              element: <ListaESG />,
            },
            {
              path: "criar",
              element: <NovoESG />,
            },
            {
              path: "editar/:id",
              element: <NovoESG />,
            },
          ],
        },
        {
          path: "colaboradores",
          children: [
            {
              path: "lista",
              element: <ListaColaboradores />,
            },
            {
              path: "criar",
              element: <NovoColaborador />,
            },
            {
              path: "trocar-senha",
              element: <TrocarSenha />,
            },
            {
              path: "detalhes-usuario",
              element: <DetalhesUsuario />,
            },
          ],
        },
        {
          path: "logs",
          children: [
            {
              path: "lista",
              element: <ListaLogs />,
            },
          ],
        },
        {
          path: "notificacoes",
          children: [
            {
              path: "lista",
              element: <ListaNotificacoes />,
            },
          ],
        },
        {
          path: "ods",
          children: [
            {
              path: "lista",
              element: <ListaOds />,
            },
            {
              path: "criar",
              element: <NovoOds />,
            },
            {
              path: "editar/:id",
              element: <NovoOds />,
            },
          ],
        },
        {
          path: "temas",
          children: [
            {
              path: "lista",
              element: <ListaTema />,
            },
            {
              path: "criar",
              element: <NovoTema />,
            },
            {
              path: "editar/:themeCode",
              element: <NovoTema />,
            },
          ],
        },
        {
          path: "grupoTemas",
          children: [
            {
              path: "lista",
              element: <ListaGrupoTemas />,
            },
            {
              path: "criar",
              element: <NovoGrupoTemas />,
            },
            {
              path: "editar/:id",
              element: <NovoGrupoTemas />,
            },
          ],
        },
        {
          path: "impactoEsg",
          children: [
            {
              path: "lista",
              element: <ListaImpactoEsg />,
            },
            {
              path: "criar",
              element: <NovoImpactoEsg />,
            },
            {
              path: "editar/:id",
              element: <NovoImpactoEsg />,
            },
          ],
        },
        {
          path: "indicadores",
          children: [
            {
              path: "lista",
              element: <ListaIndicadores />,
            },
            {
              path: "criar",
              element: <NovoIndicador />,
            },
            {
              path: "editar/:id",
              element: <NovoIndicador />,
            },
          ],
        },
        {
          path: "coleta",
          children: [
            {
              path: "lista",
              element: <ListaColeta />,
            },
            {
              path: "criar",
              element: <NovaColeta />,
            },
            {
              path: "editar/:id",
              element: <NovaColeta />,
            },
          ],
        },
        {
          path: "dimensao",
          children: [
            {
              path: "lista",
              element: <ListaDimensao />,
            },
            {
              path: "criar",
              element: <NovaDimensao />,
            },
            {
              path: "editar/:id",
              element: <NovaDimensao />,
            },
          ],
        },
        {
          path: "medida",
          children: [
            {
              path: "lista",
              element: <ListaMedida />,
            },
            {
              path: "criar",
              element: <NovaMedida />,
            },
            {
              path: "editar/:id",
              element: <NovaMedida />,
            },
          ],
        },
        {
          path: "fonteDeDados",
          children: [
            {
              path: "lista",
              element: <ListaFonteDeDados />,
            },
            {
              path: "criar",
              element: <NovaFonteDeDados />,
            },
            {
              path: "editar/:id",
              element: <NovaFonteDeDados />,
            },
          ],
        },
        {
          path: "fatoresEmissao",
          children: [
            {
              path: "lista",
              element: <ListaFatoresEmissao />,
            },
            {
              path: "criar",
              element: <NovoFatoresEmissao />,
            },
            {
              path: "editar/:id",
              element: <NovoFatoresEmissao />,
            },
          ],
        },
        {
          path: "gestaoColeta",
          children: [
            {
              path: "lista",
              element: <ListaGestaoColeta />,
            },
          ],
        },
        {
          path: "frameworks",
          children: [
            {
              path: "lista",
              element: <ListaFrameworks />,
            },
            {
              path: "criar",
              element: <NovoFramework />,
            },
            {
              path: "editar/:id",
              element: <NovoFramework />,
            },
          ],
        },
        {
          path: "padroesFrameworks",
          children: [
            {
              path: "lista",
              element: <ListaPadroesFrameworks />,
            },
            {
              path: "criar",
              element: <NovoPadroesFrameworks />,
            },
            {
              path: "editar/:id",
              element: <NovoPadroesFrameworks />,
            },
          ],
        },
        {
          path: "priorizacao",
          children: [
            {
              path: "lista",
              element: <ListaPriorizacao />,
            },
            {
              path: "criar",
              element: <NovaPriorizacao />,
            },
            {
              path: "editar/:id",
              element: <NovaPriorizacao />,
            },
          ],
        },
        {
          path: "testes",
          children: [
            {
              path: "lista",
              element: <ListaTestes />,
            },
            {
              path: "criar",
              element: <NovoTeste />,
            },
          ],
        },
        {
          path: "engagement",
          children: [
            {
              path: "projetos",
              children: [
                {
                  path: "lista",
                  element: <ListaProjetosEngagement />,
                },
                {
                  path: "criar",
                  element: <NovoProjetoEngagement />,
                },
              ],
            },
            {
              path: "objetivos",
              children: [
                {
                  path: "criar",
                  element: <NovoObjetivoEngagement />,
                },
              ],
            },
            {
              path: "tarefas",
              children: [
                {
                  path: "criar",
                  element: <NovaTarefaEngagement />,
                },
              ],
            },
            {
              path: "coletas",
              children: [
                {
                  path: "criar",
                  element: <NovaColetaEngagement />,
                },
              ],
            },
            {
              path: "steps",
              children: [
                {
                  path: "criar",
                  element: <NovoStepEngagement />,
                },
              ],
            },
            {
              path: "programacoes",
              children: [
                {
                  path: "lista",
                  element: <ListaProgramacoesEngagement />,
                },
                {
                  path: "criar",
                  element: <NovaProgramacaoEngagement />,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      path: "/auth",
      element: <PagesLayout />,
      children: [
        {
          path: "login",
          element: <AuthLogin />,
        },
        {
          path: "register",
          element: <AuthRegister />,
        },
      ],
    },
    {
      path: "/",
      element: <SimpleLayout layout={SimpleLayoutType.SIMPLE} />,
      children: [],
    },
  ],
};

export default MainRoutes;
